import React from 'react';
import { useNavigate } from 'react-router-dom';


const Backoffice = () => {
    const navigate = useNavigate();




    return (
        <div className="backoffice-container" style={{
            minHeight: '100vh',
            backgroundColor: '#f8f9fa'
        }}>
            {/* Header */}
            <header style={{
                backgroundColor: '#2c3d4f',
                color: '#ffffff',
                padding: '20px 30px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '24px' }}>Backoffice CMS</h2>

                    </div>
                    <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                        <button
                            onClick={() => navigate('/')}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#d89d37',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            View Site
                        </button>
                        <button
                            style={{
                                padding: '10px 20px',
                                backgroundColor: 'transparent',
                                color: '#ffffff',
                                border: '1px solid #ffffff',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <div className="container" style={{ padding: '40px 20px' }}>
                <div className="row">
                    <div className="col-12">
                        <h1 style={{ marginBottom: '30px', color: '#2c3d4f' }}>
                            Welcome to the Backoffice
                        </h1>
                    </div>
                </div>

                {/* Dashboard Cards */}
                <div className="row">
                    {[
                        { title: 'Properties', count: '0', icon: '🏠', color: '#d89d37' },
                        { title: 'Reservations', count: '0', icon: '📅', color: '#4285F4' },
                        { title: 'Users', count: '0', icon: '👥', color: '#34A853' },
                        { title: 'Messages', count: '0', icon: '✉️', color: '#EA4335' }
                    ].map((item, index) => (
                        <div className="col-lg-3 col-md-6 mb-4" key={index}>
                            <div style={{
                                backgroundColor: '#ffffff',
                                padding: '30px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 15px rgba(0,0,0,0.1)',
                                textAlign: 'center',
                                borderTop: `4px solid ${item.color}`,
                                transition: 'transform 0.3s',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <div style={{ fontSize: '48px', marginBottom: '15px' }}>
                                    {item.icon}
                                </div>
                                <h3 style={{ color: '#2c3d4f', marginBottom: '10px' }}>
                                    {item.title}
                                </h3>
                                <p style={{ fontSize: '32px', fontWeight: 'bold', color: item.color, margin: 0 }}>
                                    {item.count}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Management Sections */}
                <div className="row mt-5">
                    <div className="col-12">
                        <h2 style={{ marginBottom: '30px', color: '#2c3d4f' }}>
                            Content Management
                        </h2>
                    </div>

                    {[
                        { title: 'Manage Properties', description: 'Add, edit, or remove properties', icon: '🏠' },
                        { title: 'Manage Services', description: 'Update services and pricing', icon: '⚙️' },
                        { title: 'Manage Team', description: 'Add or update team members', icon: '👥' },
                        { title: 'Manage Testimonials', description: 'Review and approve testimonials', icon: '⭐' },
                        { title: 'Manage Blog', description: 'Create and edit blog posts', icon: '📝' },
                        { title: 'Settings', description: 'Configure site settings', icon: '🔧' }
                    ].map((section, index) => (
                        <div className="col-lg-4 col-md-6 mb-4" key={index}>
                            <div style={{
                                backgroundColor: '#ffffff',
                                padding: '25px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s',
                                cursor: 'pointer',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.15)';
                                e.currentTarget.style.transform = 'translateY(-3px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                            >
                                <div style={{
                                    fontSize: '36px',
                                    marginBottom: '15px'
                                }}>
                                    {section.icon}
                                </div>
                                <h4 style={{ color: '#2c3d4f', marginBottom: '10px' }}>
                                    {section.title}
                                </h4>
                                <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
                                    {section.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Backoffice;